import React from 'react';
import { Helmet } from 'react-helmet';
import { observer } from 'mobx-react';
import { useTranslation } from 'react-i18next';
import { withErrorBoundary } from 'react-error-boundary';

import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import ViewLoader from 'components/Loading/View';

const PartnerStudentsDashboard = React.lazy(
  () =>
    import(
      /* webpackChunkName: 'partner-enrollments' */ 'components/Partner/Enrollments'
    ),
);

const PartnerStudentsView = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet title={`${t('Subscriptions')} - Red Hat Learning`} />
      <React.Suspense fallback={<ViewLoader />}>
        <PartnerStudentsDashboard />
      </React.Suspense>
    </>
  );
};

export default withErrorBoundary(
  observer(PartnerStudentsView),
  GenericViewError,
  handleError,
);
